// src/store/appPreviewSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppPreviewState {
  data: any | null;
  previewUrl: string | null;
}

const initialState: AppPreviewState = {
  data: null,
  previewUrl: null,
};

const appPreviewSlice = createSlice({
  name: "appPreview",
  initialState,
  reducers: {
    setAppPreview(state, action: PayloadAction<any>) {
      state.data = action.payload;
      if (action.payload?.preview_url) {
        state.previewUrl = action.payload.preview_url;
      } else if (action.payload?.success !== false) {
        state.previewUrl = null;
      }
    },
    clearAppPreview(state) {
      state.data = null;
      state.previewUrl = null;
    },
  },
});

export const { setAppPreview, clearAppPreview } = appPreviewSlice.actions;
export default appPreviewSlice.reducer;
